import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { fetchRoomById } from '../reducers/RoomSlice';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';

const ViewRooms = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { room, status, error } = useSelector(state => state.rooms);

    useEffect(() => {
        if (id) {
            dispatch(fetchRoomById(id));
        }
    }, [id, dispatch]);

    if (status === 'loading') {
        return <div className="d-flex justify-content-center align-items-center h-100"><CircularProgress /></div>;
    }

    if (status === 'failed') {
        return <div>Failed to load room data: {error}</div>;
    }

    if (!room) {
        return <div>No room data available.</div>;
    }

    return (
        <>
            <div className="container my-4 text-white view-room">
                <div className="row" id="roomContainer">
                    <div className="col">
                        <div className="card-body">
                            <div className="card room-card p-4">
                                <h2 className='text-center text-white mb-2'>AK Boys Hostel</h2>
                                <div className="same-divs"><strong>Room ID:</strong> {room._id || ''}</div>
                                <div className="same-divs"><strong>Room NO:</strong> {['Room 1', 'Room 13', 'Room 14', 'Room 26', 'Room 27'].includes(room.roomNumber)
                                    ? `${room.roomNumber} (VIP)`
                                    : room.roomNumber ?? ''}
                                </div>
                                <div className="same-divs"><strong>Room Type:</strong> {room.roomType || ''}</div>
                                <div className="same-divs"><strong>Floor NO:</strong> {room.floorNumber || ''}</div>
                                <div className="same-divs"><strong>Capacity:</strong> {room.capacity || ''}</div>
                                <div className="same-divs"><strong>Available Beds:</strong> {room.availableBeds || ''}</div>
                                <div className="same-divs"><strong>Monthly Rent:</strong> {room.monthlyRent ? `${room.monthlyRent?.toLocaleString()} PKR` : ''}</div>
                                <div className="same-divs"><strong>Available From:</strong> {room.availableFrom || ''}</div>
                                <div className="same-divs"><strong>Facilities:</strong> {room.facilities?.join(', ') || ''}</div>
                                <div className="same-divs"><strong>Notes:</strong> {room.notes || ''}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewRooms;
